'use client';

import { Box, Grid, Typography, Paper } from '@mui/material';
import { useTranslations } from 'next-intl';

const MissionSection = () => {
    const t = useTranslations('AboutPage.mission_section');

    const items = [
        { title: t('mission_title'), desc: t('mission_desc') },
        { title: t('vision_title'), desc: t('vision_desc') },
    ];

    return (
        <Box sx={{ py: 6 }}>
            <Grid container spacing={4}>
                {items.map((item, index) => (
                    <Grid size={{ xs: 12, sm: index == 2 ? 12 : 6, md: index == 2 ? 12 : 6 }} key={index}>
                        <Paper
                            elevation={0}
                            sx={{
                                p: 5,
                                height: '100%',
                                borderRadius: '16px',
                                border: '1px solid #e2e8f0',
                                boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.05)',
                                textAlign: "center"
                            }}
                        >
                            <Typography variant="h5" sx={{ fontWeight: 800, color: '#132c4b', mb: 2 }}>
                                {item.title}
                            </Typography>
                            {item.desc && (
                                <Typography variant="body1" sx={{ color: '#64748b', lineHeight: 1.6 }}>
                                    {item.desc}
                                </Typography>
                            )}
                        </Paper>
                    </Grid>
                ))}
            </Grid>
        </Box>
    );
};

export default MissionSection;
